/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ConstraintsRequest {
    getFixupPrototypeFunction() { return ConstraintsRequest.fixupPrototype; }

    static newInstance(model: Partial<ConstraintsRequest>): ConstraintsRequest {
        let obj = Object.assign(new ConstraintsRequest(), model);
        ConstraintsRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ConstraintsRequest>): ConstraintsRequest {
        if (!model) return null;
        return ConstraintsRequest.newInstance(<ConstraintsRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ConstraintsRequest) {
        if (!obj) return;

        models.ConstraintsRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ConstraintsRequest): boolean {
        Object.setPrototypeOf(obj, ConstraintsRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Option Value of Tag Details
     */
    option: models.ConstraintsOption;

    /**
     * Type of Template Details
     */
    type: models.ConstraintsType;

    /**
     * Tag keys and Tag values of Template Details. eg) {\"XZV\":[\"ZNCDF\", \"dfsgsg\"]}
     */
    tags: any;

}
